import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gamesTagFilter'
})
export class GamesTagFilterPipe implements PipeTransform {

  transform(games: Array<any>, tag:string): any {
    return games.filter(game => {
      return game["tagList"] && game["tagList"].length>0  && game["tagList"].indexOf(tag) !== -1;
    });
  }

}

@Pipe({
  name: 'gameTagFilter'
})
export class GameTagFilterPipe implements PipeTransform {

  transform(game:any, tag:string): any {
    
    return game["tagList"] && game["tagList"].length>0  && game["tagList"].indexOf(tag) !== -1
  }

}



